import { render, staticRenderFns } from "./SolicitacaoRealizada.vue?vue&type=template&id=0beb8e29"
import script from "./SolicitacaoRealizada.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRealizada.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoRealizada.vue?vue&type=style&index=0&id=0beb8e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports